import { mapStateToLayoutProps, rankWith } from '@jsonforms/core';
import { html, repeat } from '@microsoft/fast-element';
import { LAYOUT_HORIZONTAL_RANK } from './RenderersRanks';
export const LayoutHorizontalRendererTemplate = html `
  <template>
    <div
      style="
      display: flex;
      flex-direction: row;
      gap: 10px"
    >
      ${repeat((x) => x.control.uischema.elements, html `
          <dispatch-renderer
            ?submitted=${(x, ctx) => ctx.parent.submitted}
            :dispatch=${(x, ctx) => ctx.parent.dispatch}
            :jsonforms=${(x, ctx) => ctx.parent.jsonforms}
            :props=${(x, ctx) => ({
    uischema: x,
    schema: ctx.parent.control.schema,
    renderers: ctx.parent.control.renderers,
    path: ctx.parent.control.path,
    enabled: ctx.parent.control.enabled,
})}
          ></dispatch-renderer>
        `)}
    </div>
  </template>
`;
export const LayoutHorizontalEntry = {
    renderer: LayoutHorizontalRendererTemplate,
    tester: rankWith(LAYOUT_HORIZONTAL_RANK, (uiSchema) => uiSchema.type === 'HorizontalLayout'),
    mapper: mapStateToLayoutProps,
};
